// Structure du cours "Tempalte"
import courseImage from './course-image.jpg';

export const courseStructure = {
  id: 'ameliorevisée',
  title: 'Jeu 1 : Améliore ta visée ',
  image: courseImage,
  chapters: [
    {
      id: 'introduction',
      title: 'Introduction',
      path: '/cours/ameliorevisée'
    },
    {
      id: 'chapitre1',
      title: 'La boucle de jeu',
      path: '/cours/ameliorevisée/chapitre1'
    },
    {
      id: 'chapitre2',
      title: 'Cliquer sur le cercle',
      path: '/cours/ameliorevisée/chapitre2'
    },
    {
      id: 'chapitre3',
      title: 'Score, timer et status',
      path: '/cours/ameliorevisée/chapitre3'
    },
    {
      id: 'chapitre4',
      title: 'Ecran de début et de fin',
      path: '/cours/ameliorevisée/chapitre4'
    }
  ]
}; 